<template>
  <div class="icon-card-page">
    <div class="icon-card-container">
      <div class="icon-card-row">
        <CalicoIconCard class="icon-card">
          <i class="bi bi-shop contained-icon-medium" />
          <h1 class="heading--xsmall">
            Evaluate risk
          </h1>
          <p class="body--medium">
            This is a Status Card element. It has a badge
            that indicates a status of content the card navigates to.
          </p>
          <button class="button-primary--large">
            Button
          </button>
        </CalicoIconCard>
        <CalicoIconCard class="icon-card">
          <i class="bi bi-shop contained-icon-medium" />
          <h1 class="heading--xsmall">
            Evaluate risk
          </h1>
          <p class="body--medium">
            This is a Status Card element. It has a badge
            that indicates a status of content the card navigates to.
          </p>
          <button class="button-primary--large">
            Button
          </button>
        </CalicoIconCard>
        <CalicoIconCard class="icon-card">
          <i class="bi bi-shop contained-icon-medium" />
          <h1 class="heading--xsmall">
            Evaluate risk
          </h1>
          <p class="body--medium">
            This is a Status Card element. It has a badge
            that indicates a status of content the card navigates to.
          </p>
          <button class="button-primary--large">
            Button
          </button>
        </CalicoIconCard>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoIconCard from '@/components/calico/iconCard/index.vue';

export default {
  name: 'CalicoIconCardPage',
  components: {
    CalicoIconCard,
  },
};
</script>

<style lang="scss">
.icon-card-page {
  display: flex;
  justify-content: center;
  align-items: center;

  .icon-card-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;

    .icon-card-row {
      @include inline-space($space-large);
      @include inset-space($space-large);

      p {
        margin: 0%;
      }

      button {
        width: fit-content;
      }
    }
  }
}
</style>